export default __webpack_public_path__ + "static/media/dots.42e0240e.svg";